// Libraries
import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import clsx from "clsx";

// Context
import { useSalesLogChart } from "@/DataPages/context/salesOperations/salesLog/SalesLogChartsContext";

// Types
import { TDealTypeKey } from "@/DataPages/types/salesOperations/salesLog/utils";

export default function IncludeCheckBoxFilter() {
	const { includedDealType, setIncludedDealType } = useSalesLogChart();

	return (
		<>
			<Typography variant={"appLabel"}>Include: </Typography>
			<FormGroup className="!flex-row">
				{Object.entries(includedDealType).map(
					(
						[key, { disabled, included, name }]: [string, { disabled: boolean; included: boolean; name: string }],
						index: number
					) => (
						<FormControlLabel
							key={key}
							control={
								<Checkbox
									checked={included}
									onChange={(event) => {
										const value = event.target.checked;
										setIncludedDealType({
											type: key as TDealTypeKey,
											payload: { ...includedDealType[key as TDealTypeKey], included: value },
										});
									}}
									disabled={disabled}
								/>
							}
							label={name}
							classes={{
								root: clsx({ "!ml-1": index === 0, "!ml-3": index !== 0, "!mr-0": true }),
							}}
						/>
					)
				)}
			</FormGroup>
		</>
	);
}
